import React from 'react'
import { compose, withHandlers } from 'recompose'
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'

const FacebookButton = ({ doFacebookLogin, text }) => {
  return (
    <FacebookLogin
      appId={process.env.REACT_APP_FB_APP_ID}
      callback={doFacebookLogin}
      fields="first_name,last_name,email"
      disableMobileRedirect={true}
      render={renderProps => (
        <button
          type="button"
          onClick={renderProps.onClick}
          className="facebook_button">
          <i className="fab fa-facebook-f" />{' '}
          <span>{text ? text : 'Continue with Facebook'}</span>
        </button>
      )}
    />
  )
}

export default compose(
  withHandlers({
    doFacebookLogin: ({ setValues, submitForm, setErrors }) => res => {
      if (res.email && res.first_name && res.last_name) {
        setValues({
          firstName: res.first_name,
          lastName: res.last_name,
          email: res.email,
          password: process.env.REACT_APP_MAGENTO_TAG
        })
        submitForm()
        return
      }
      setErrors({ facebookLogin: 'We could not log in on facebook' })
    }
  })
)(FacebookButton)



// WEBPACK FOOTER //
// ./src/modules/Checkout/AccountForm/FacebookButton.jsx